import { WIDGET_VIEW_NUMBER } from "@smallstack/typesystem";
import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const NumberViewWidget: WidgetRegistryEntry = {
  name: WIDGET_VIEW_NUMBER,
  component: () => import("./number-view-widget.component").then((m) => m.NumberViewWidgetComponent)
};
